import { Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getUserEntity } from 'common/UserEntityProvider';
import { hasPermission, hasRole, hasFunctionality } from 'components/authorization/PermissionUtils';
import { ENTITY_TYPE } from 'common/constants';

export default function DefaultActions({
  row,
  entityType,
  onEdit,
  onDelete,
  onView,
  editScopes,
  viewScopes,
  deleteScopes,
  identifier,
  disabled = false,
}: {
  row: any;
  entityType: ENTITY_TYPE;
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  onView?: (row: any) => void;
  editScopes?: string[];
  viewScopes?: string[];
  deleteScopes?: string[];
  identifier?: string;
  disabled?: boolean;
}) {
  const handleEdit = () => {
    onEdit(row);
  };

  const handleDelete = () => {
    onDelete(row);
  };

  const handleView = () => {
    onView(row);
  };
  const handleClick = (action: string) => {
    switch (action) {
      case 'edit':
        handleEdit();
        break;
      case 'delete':
        handleDelete();
        break;
      case 'view':
        handleView();
        break;
      default:
        break;
    }
  };

  function checkPermission(scopes, entityType) {
    const userEntity = getUserEntity();
    return (
      (hasPermission({ scopes }) || scopes.length === 0) &&
      (entityType === userEntity?.entityType || entityType === ENTITY_TYPE.ANY)
    );
  }

  const canEdit = identifier
    ? onEdit && hasFunctionality(identifier, 'edit')
    : editScopes && checkPermission(editScopes, entityType);
  const canView = identifier
    ? onView && hasFunctionality(identifier, 'view')
    : viewScopes && checkPermission(viewScopes, entityType);
  const canDelete = identifier
    ? onDelete && hasFunctionality(identifier, 'view')
    : deleteScopes && checkPermission(deleteScopes, entityType);

  return (
    <Box display="flex" justifyContent="center">
      {canEdit && (
        <IconButton onClick={() => handleClick('edit')} disabled={disabled}>
          <EditIcon />
        </IconButton>
      )}
      {canView && (
        <IconButton onClick={() => handleClick('view')} disabled={disabled}>
          <VisibilityIcon />
        </IconButton>
      )}
      {canDelete && (
        <IconButton onClick={() => handleClick('delete')} disabled={disabled}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
}
